import { useApiData } from '../useApiData';
import { setOrderHistory } from 'store/orderHistory/actions';

export const useOrderHistoryApi = id => {
    useApiData(`/order/${id}`, setOrderHistory);
};
